<template>
    <div class="container px-lg-5 previsit">
        <link
            :href="`/view/surveyjs/defaultV2.min.css?v=${SURVEYJS_VERSION}`"
            rel="stylesheet"
            type="text/css"
            media="all"
        />
        <div class="row">
            <div class="col py-3">
                <div class="card content">
                    <!-- here the top header -->
                    <div
                        class="header-footer"
                        v-if="
                            this.isShowHeaderFooter &&
                            !this.isLoadingAppointment &&
                            this.business
                        "
                    >
                        <div class="webform-header row">
                            <div class="webform-logo col-sm my-auto text-left">
                                <img
                                    :src="businessLogo"
                                    class="h-auto"
                                    style="max-width: 175px;"
                                />
                            </div>
                            <div class="col-sm text-right my-auto">
                                <div>
                                    <strong>{{ business.label }}</strong>
                                </div>
                                <div
                                    v-html="business.business_full_address"
                                ></div>
                                <div v-if="business.phone">
                                    Phone:
                                    <PhoneNumber
                                        :phone="business.phone"
                                        :phoneCountry="
                                            business.phone_country_code
                                        "
                                    />
                                </div>
                                <div v-if="business.fax">
                                    Fax:
                                    <PhoneNumber
                                        :phone="business.fax"
                                        :phoneCountry="
                                            business.fax_country_code
                                        "
                                    />
                                </div>
                                <div>
                                    <a
                                        :href="'mailto:' + business.email"
                                        data-rel="external"
                                        >{{ business.email }}
                                    </a>
                                </div>

                                <div>
                                    <a
                                        :href="`//${business.website}`"
                                        target="_blank"
                                        >{{ business.website }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="form-title"
                        v-if="
                            isShowHeaderFooter &&
                            webforms &&
                            webforms.length > 0
                        "
                    >
                        <h2>
                            Check-In Forms
                            <span class="text-nowrap"
                                >({{ page + 1 }} of {{ webforms.length }})</span
                            >
                        </h2>
                        <h6 class="mb-0">
                            Please review the information below.
                        </h6>
                    </div>
                    <div
                        v-if="isLoadingAppointment || isSaving"
                        class="spinner-wrapper"
                    >
                        <b-spinner variant="secondary" />
                        <span v-if="isLoadingAppointment">Loading...</span>
                        <span v-else>Saving...</span>
                    </div>
                    <div
                        v-else-if="!isLoadingAppointment && showMessage === ''"
                        class="h-100"
                    >
                        <SurveyWebform
                            v-if="
                                webforms &&
                                webforms.length > 0 &&
                                webforms[page]
                            "
                            ref="webform"
                            :key="page"
                            :webform="webforms[page]"
                            :is-previsit="false"
                            @webform-completed="webformCompleted"
                            @trigger-next-doc="nextDoc"
                            @isLoading="
                                isLoading => (isWebformLoading = isLoading)
                            "
                            @updateCurrentWebformPage="
                                activePage => (currentWebformPage = activePage)
                            "
                        />
                    </div>
                    <div
                        v-else-if="!isLoadingAppointment && showMessage !== ''"
                        class="spinner-wrapper text-center"
                    >
                        <p>
                            {{ showMessage }}

                            <span v-if="isRedirecting">
                                <br />
                                <br />
                                <div class="spinner-wrapper">
                                    <b-spinner variant="secondary" />
                                    <span
                                        >Opening external
                                        {{
                                            uniqueUrls.length > 0
                                                ? "URLS"
                                                : "URL"
                                        }}...</span
                                    >
                                </div>
                                <p>
                                    You will be redirected to
                                    {{ uniqueUrls.join(", ") }}
                                </p>
                            </span>
                        </p>
                    </div>
                    <div
                        v-if="
                            !isLoadingAppointment &&
                            !isSaving &&
                            !isCompleted &&
                            webforms &&
                            webforms.length > 0 &&
                            !isWebformLoading
                        "
                        class="card-footer vetter"
                    >
                        <div
                            class="justify-content-md-end justify-content-sm-center d-flex"
                        >
                            <button
                                v-if="isShowPrevious"
                                type="button"
                                class="btn btn-secondary col-md-4 col-xl-3 m-0 mr-2 text-nowrap"
                                @click="preWebform"
                            >
                                {{ prevText }}
                            </button>
                            <button
                                v-if="isLastPage && !isWebformSubmitted"
                                type="button"
                                class="btn btn-primary float-right col-md-4 col-xl-3 m-0 text-nowrap"
                                @click="nextWebform"
                            >
                                {{ completeText }}
                            </button>
                            <button
                                v-else-if="!isLastPage"
                                type="button"
                                class="btn btn-primary float-right col-md-4 col-xl-3 m-0 text-nowrap"
                                @click="nextWebform"
                            >
                                {{ isStartPage ? startText : nextText }}
                            </button>
                        </div>
                    </div>

                    <hr class="m-0" />

                    <div class="header-footer" v-if="isShowHeaderFooter">
                        <div class="row">
                            <loader-custom
                                v-if="isLoadingFooter"
                                class="w-100"
                            />
                            <div
                                v-else
                                class="col m-auto webform-footer"
                                v-html="webformFooter"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*
this file is not located within the "layout.vue".
it means that anything in "helper.js" won't work here
unless we explicitly import the file.
for example: "this._message()" don't work
*/
import { map, sortBy } from "lodash";
import "@/scss/previsit.scss";
import axios from "axios";
import AWSs3Mixin from "@/mixins/awss3";
import WebformMixin from "@/mixins/webform";

export default {
    mixins: [AWSs3Mixin, WebformMixin],
    components: {
        PhoneNumber: () => import("@/components/commons/phone-number"),
        LoaderCustom: () => import("@/components/elements/loader-custom.vue"),
        SurveyWebform: () => import("@/module/schedule/previsit/webform.vue")
    },
    data() {
        return {
            isLoadingAppointment: true,
            isLoadingFooter: true,
            isShowHeaderFooter: false,
            showMessage: "",
            isSaving: false,
            business: null,
            appointment: null,
            webforms: [],
            webformFooter: "",
            page: 0,
            isCompleted: false,
            isWebformLoading: true,
            currentWebformPage: null,
            isRedirecting: false,
            uniqueUrls: []
        };
    },
    computed: {
        businessLogo() {
            return (
                this._s3URL("business", this.business.id) +
                "photos/thumb_" +
                this.business.photo
            );
        },
        appointmentId() {
            return this.$route.params.id;
        },
        isShowPrevious() {
            return this.currentWebformPage?.isShowPrevButton;
        },
        isLastPage() {
            return (
                this.webforms.length === this.page + 1 &&
                this.currentWebformPage?.isLastPage
            );
        },
        isStartPage() {
            return this.currentWebformPage?.isStartPage;
        },
        isWebformSubmitted() {
            return this.webforms[this.page].submitted_at;
        },
        nextText() {
            return this.currentWebformPage?.pageNextText ?? "Next";
        },
        completeText() {
            return "Submit";
            // by default show submit only as will submit multiple forms
            // return this.currentWebformPage?.completeText ?? "Submit";
        },
        prevText() {
            return this.currentWebformPage?.pagePrevText ?? "Previous";
        },
        startText() {
            return this.currentWebformPage?.startSurveyText ?? "Start";
        }
    },
    mounted() {
        document.getElementById("app").style.height = "100vh";
        this.fetchData();
        // remove heartbeat
        let hb = document.getElementById("the-heartbeat");
        if (hb) {
            hb.style.display = "none";
        }
    },
    methods: {
        preWebform() {
            this.$refs.webform.prevPage();
        },
        nextWebform() {
            this.$refs.webform.nextPage();
        },
        webformCompleted(data) {
            Object.assign(this.webforms[this.page], data);
            this.nextDoc();
        },
        nextDoc() {
            if (this.webforms.length > this.page + 1) {
                this.currentWebformPage = null;
                this.page++;
            } else {
                this.submit();
            }
        },
        async fetchFooter(businessId) {
            // Webform footer is from Setting > Configuration
            this.isLoadingFooter = true;
            let res = await axios({
                method: "get",
                url: `account/setting-by-business/${businessId}`,
                baseURL: process.env.BARRAMUNDI
            });
            this.isLoadingFooter = false;

            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resource
            ) {
                this.webformFooter =
                    res.data.response.resource.form_footer ||
                    "Powered By Daysmart Vet";
            }
        },
        async fetchData() {
            try {
                this.isLoadingAppointment = true;
                this.isShowHeaderFooter = false;

                let res = await axios({
                    method: "post",
                    url: "schedule/checkin-webforms/" + this.appointmentId,
                    params: {
                        encoded: true,
                        is_checkin: true
                    },
                    baseURL: process.env.BARRAMUNDI
                });

                if (
                    res &&
                    res.data &&
                    res.data.response &&
                    res.data.response.resource
                ) {
                    this.webforms = sortBy(
                        res.data.response.resource.webforms,
                        "title"
                    );

                    if (this.webforms.length > 0) {
                        this.appointment =
                            res.data.response.resource.appointment;
                        this.business = this.appointment.business;
                        await this.fetchFooter(this.business.id);
                        this.isShowHeaderFooter = true;
                    } else {
                        throw new Error("Form not available");
                    }
                } else {
                    throw new Error("Form not available");
                }
            } catch (e) {
                this.isShowHeaderFooter = false;
                this.showMessage = e.message;
            } finally {
                this.isLoadingAppointment = false;
            }
        },
        async submit() {
            const promises = [];
            this.isSaving = true;
            this.isCompleted = true;

            this.webforms.forEach(webform => {
                promises.push(
                    this.triggerGeneratePDF(webform).then(webformLink => {
                        webform["s3_link"] = webformLink;
                    })
                );
            });

            await Promise.all(promises).then(() => {
                const webforms = map(this.webforms, webform => {
                    return {
                        id: webform.id,
                        content: webform.webformContent,
                        answers: webform.webformAnswer,
                        s3_link: webform.s3_link
                    };
                });

                axios
                    .post(
                        `${process.env.BARRAMUNDI}schedule/checkin-webforms/${this.appointmentId}/submit`,
                        {
                            encoded: true,
                            webform_inputs: webforms
                        },
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    )
                    .then(async res => {
                        if (res) {
                            this.showMessage =
                                this.webforms.length == 1
                                    ? "The form has been submitted"
                                    : "All forms have been submitted";

                            this.isSaving = false;
                            await this._sleep(1000);
                            this.navigateToUrls(this.webforms);
                        } else {
                            throw new Error("Error on submit check-in forms");
                        }
                    })
                    .catch(e => {
                        console.error("Error on submit check-in forms");
                        this.isSaving = false;
                    });
            });
        },
        triggerGeneratePDF(webform) {
            // Generate PDF
            return Promise(async (myResolve, myReject) => {
                const senderData = await this.convertBase64ToS3(
                    webform.webformAnswer,
                    Object.assign(webform, {
                        path: `webform/client/${webform.client_id}/${webform.id}`,
                        webformId: webform.id,
                        jsonType: "answer"
                    })
                );

                const webformLink = await this.generatePdf(
                    webform,
                    webform.webformContent,
                    senderData
                );
                myResolve(webformLink);
            });
        }
    }
};
</script>

<style lang="scss">
@import "@/scss/spinner.scss";

body {
    background-color: #fff;
}
</style>

<style scoped lang="scss">
.content {
    min-height: 100vh;
    height: 100%;
}
.header-footer {
    background-color: #fbfbfb;
    border-top-right-radius: inherit;
    border-top-left-radius: inherit;
    border-bottom: 1px solid;
    border-color: inherit;
    padding: 10px 24px;
    align-items: center;
}
@media (max-width: 576px) {
    .webform-header .webform-logo {
        text-align: center !important;
        padding: 20px 0;
    }
}

// Follow the previsit UI except the font-family
.form-title {
    padding: 24px 24px 0px;

    h2 {
        font-size: 32px;
        color: #4a4a4a;
    }

    h6 {
        font-size: 16px;
        font-weight: 300;
        text-transform: none;
        padding-bottom: 0.5em;
    }
}

.vetter .btn-secondary {
    color: #212529;
}
</style>
